// extracted by mini-css-extract-plugin
module.exports =  {"spinner":"_93444fe79c--spinner--uXgOG","circle-spin":"_93444fe79c--circle-spin--HhIQz"};